import styles from './IntroductionWidget.module.scss';
import { RoundIcon } from '../../../icon/RoundIcon';

export interface IntroductionWidgetIconProps {
  dataId: string;
  iconName: string;
}

export function IntroductionWidgetIcon({ dataId, iconName }: IntroductionWidgetIconProps) {
  return (
    <div className={styles.entityIconContainer}>
      <RoundIcon
        dataId={dataId}
        iconName={iconName}
        containerBg='primary-faded'
        containerSize={9}
        iconClasses='text-primary'
        isIconColorWhite={false}
      />
    </div>
  );
}
